module.exports = __webpack_public_path__ + "img/158.9af2416b.jpg";